export function albumPath(album) {
  if (album.slug || album.albumSlug)
    return `/reviews/${encodeURIComponent(album.slug || album.albumSlug)}`;
  if (album.id || album.albumId)
    return `/reviews/local/${encodeURIComponent(album.id || album.albumId)}`;
  const source = String(album.albumSource || 'APPLE_MUSIC').toLowerCase();
  return `/reviews/${source}/${encodeURIComponent(album.sourceId)}`;
}
